module.exports = __webpack_public_path__ + "check-green.740ac2f73beabb010d6b4331b9609129.svg";